import Vue from "vue";
import Switches from "vue-switches";
import store from "./../../../store";
import mixin from "../../../mixins/mixin";
import shortCodes from "../../../mixins/shortCodes";
import channelService from "../../../services/channel";
import automationService from "../../../services/automation";
import ColorPicker from "./../../../components/colorpicker/Colorpicker";
import Datepicker from "vuejs-datepicker";
import { en, fr } from "vuejs-datepicker/dist/locale";
import DateTimePicker from "vue2-datepicker";
import rentalService from "../../../services/rental";
import InputTag from "vue-input-tag";
import moment from "moment";

export default {
  data() {
    return {
      rentals: {},
      selectedRental: "",
      mode: "grid",
      editAutoaction: false,
      newAutoAction: {
        message: {
          notification: "",
          email: "",
          sms: "",
        },
        message_notification_en: "",
        message_notification_fr: "",
        message_notification_pt: "",
        message_notification_es: "",
        message_notification_it: "",
        message_email_en: "",
        message_email_fr: "",
        message_email_pt: "",
        message_email_es: "",
        message_email_it: "",
        message_sms_en: "",
        message_sms_fr: "",
        message_sms_pt: "",
        message_sms_es: "",
        message_sms_it: "",
        paid_status: "",
        email_subject: "",
        email_subject_en: "",
        email_subject_fr: "",
        email_subject_pt: "",
        email_subject_es: "",
        email_subject_it: "",
        message_lang: "fr",
        enable_custom_color: false,
        color: "",
      },
      phoneError: null,
      error: null,
      success: false,
      loading: true,
      trigger_times: [],
      channels: {},
      channel_ids: [],
      selectedActionOccur: {},
      shortCodeForSubject: false,
      actionType: {
        email: "email",
        sms: "sms",
        notification: "notification",
        send_airbnb_message: "send_airbnb_message",
        sendReview: "review",
      },
      action_occurs: {},
      occurs: {},
      defaultNewAutoAction: {},
      typeIsEmail: true,
      typeIsReview: false,
      redactorContent: "",
      shortCodeName: "",
      groups: [],
      checkedRentals: {},
      checkedGroups: {},
      others: [],
      allRentals: false,
      smallLoading: false,
      selectedShortCode: "",
      customShortCodes: {},
      smsIntegration: true,
      pageLanguage: localStorage.getItem("lang"),
      signBeforeDays: "",
      activeTab: "autoactions",
      newShortCode: {
        id: "",
        title: "",
        code: "",
        short_code_text: "",
      },
      shortCodeRentals: [],
      shortCodeRentalGroups: [],
      areAllRentalsChecked: true,
      editShortCode: false,
      shortCodes: [],
      areAllChannelsChecked: false,
      sendTestNotification: false,
      testNotificationData: {
        booking_id: "",
        email: "",
        autoaction_id: "",
      },
      langs: ["fr", "en", "pt", "es", "it"],
      immediateTiggerTimes: ["Immediate", "Immédiat", "Imediata", "Inmediato"],
      minutes: ["Minutes", "Minutos"],
      days: ["Hours", "Hour", "Heures", "Heure", "Hora", "Horas"],
      language: localStorage.getItem("lang") || "fr",
      focusedElement: "body",
      focusedElementObject: {},
      focusedElementType: "",
      customColorIsShown: true,
      notEmptyRentals: false,
    };
  },
  components: {
    VLayout: require("layouts/default/default.vue"),
    VPanel: require("components/panel/panel.vue"),
    Redactor: require("components/redactor/redactor.vue"),
    Switches,
    Datepicker,
    PHPUnserialize: require("php-unserialize/php-unserialize"),
    VLoading: require("components/loading/loading.vue"),
    VAutoactionHelpModal: require("components/autoaction-help-modal/autoaction-help-modal.vue"),
    InputTag,
    DateTimePicker,
    VShortCodeListModal: require("components/short-codes/ShortCodeListModal"),
    VImportNotifications: require("../modals/importNotificationsModal"),
    ColorPicker,
  },
  mixins: [mixin, shortCodes],
  async mounted() {
    if ($.fn.jquery !== "2.2.4") {
      $.noConflict();
    }

    $(document).on("click", "i[data-toggle='popover']", (e) => {
      $(e.target).popover("toggle");
    });

    $("#automation-modal").on("click", (e) => {
      if (
        $(e.target).data("toggle") !== "popover" &&
        $(e.target).parents(".popover.in").length === 0
      ) {
        $('[data-toggle="popover"]').popover("hide");
      }
    });
    const vm = this;
    await vm.get_channels();
    await vm.get_autoactions();
    await vm.setTriggerTimeDependingFromLang();
    await rentalService.getGroups(vm);
    await vm.getOtherRentals();
    await vm.change_tab();

    vm.shortCodeRentalGroups.map((group, index) => {
      group.is_checked = true;
      group.rentals.map((rental) => {
        rental.is_checked = true;
        rental.short_code_text = "";
        this.notEmptyRentals = true;
      });
    });

    vm.channels.map((channel) => {
      channel.is_checked = true;
    });
    await vm.get_custom_short_codes(vm);
  },
  watch: {
    "newAutoAction.phone_number": function () {
      const vm = this;
      if (
        vm.newAutoAction.phone_number &&
        vm.newAutoAction.phone_number.length > 0
      ) {
        // verify it only contains number or +
        if (
          !/^[+0-9]+$/.test(vm.newAutoAction.phone_number) ||
          vm.newAutoAction.phone_number[0] !== "+"
        ) {
          vm.phoneError =
            "Phone number must start with '+' and only contain numbers";
        } else {
          vm.phoneError = null;
        }
      } else if (vm.phoneError) {
        vm.phoneError = null;
      }
    },
    "newAutoAction.also_to_guest": function (newValue, oldValue) {
      if (newValue) {
        this.phoneError = null;
      }
    },
    "newAutoAction.action_type": function () {
      const vm = this;
      if (vm.newAutoAction.action_type == "email") {
        vm.typeIsEmail = true;
        vm.typeIsReview = false;
      } else if (vm.newAutoAction.action_type == "review") {
        vm.typeIsReview = true;
        vm.typeIsEmail = false;
        this.customColorIsShown = false;
      } else {
        vm.typeIsEmail = false;
        vm.typeIsReview = false;
      }
      if (vm.newAutoAction.action_occur_id === 25) {
        vm.newAutoAction.channel_id = 1;
        vm.newAutoAction.paid_status = null;
      }
    },
    typeIsEmail() {
      const vm = this;
      if (vm.typeIsEmail || vm.typeIsReview) {
        $(".redactor-toolbar").attr("style", "");
        $(".redactor-toolbar").attr("style", "visibility: visible");
      } else {
        $(".redactor-box").remove();
      }
    },
    "newAutoAction.rental_ids": function () {
      const vm = this;
      if (
        vm.newAutoAction.rental_ids == [] ||
        vm.newAutoAction.rental_ids == null ||
        vm.newAutoAction.rental_ids == "a:0:{}" ||
        vm.newAutoAction.rental_ids.length == 0
      ) {
        const index = vm.rentals.findIndex((rental) => rental.sms_integration);
        vm.smsIntegration = index !== -1;
      } else {
        const ids = vm.newAutoAction.rental_ids;
        vm.smsIntegration = false;
        for (let i = 0; i < ids.length; i++) {
          const rental = vm.rentals.filter((rental) => rental.id == ids[i])[0];
          if (rental && rental.sms_integration) {
            vm.smsIntegration = true;
            break;
          }
        }
      }
    },
    "newAutoAction.action_occur_id": function (val) {
      const vm = this;
      const index = vm.action_occurs.findIndex(
        (x) => x.id === vm.newAutoAction.action_occur_id
      );
      if (index !== -1) {
        const name = vm.action_occurs[index].name;
        vm.getSignBeforeDays(name);
      } else {
        vm.signBeforeDays = "";
      }
      if (vm.newAutoAction.action_occur_id === 25) {
        vm.newAutoAction.channel_id = 1;
        vm.newAutoAction.paid_status = null;
      }
      const array = [6, 7, 8];
      this.customColorIsShown = !array.includes(val);
    },
    "account.lang": function () {
      this.language = localStorage.getItem("lang") || "fr";
    },
  },
  methods: {
    closeAutomationModal() {
      this.newAutoAction.color = "#D7092E";
      this.closeModal("#automation-modal");
    },

    updateCurrentColor(val) {
      this.newAutoAction.color = val;
    },

    new_autoaction() {
      const vm = this;
      vm.editAutoaction = false;
      vm.openModal("#automation-modal");
      vm.checkedRentals = {};
      vm.checkedGroups = {};
      vm.allRentals = false;

      $("#redactor-uuid-0").html("");
      vm.langs.map((lang) => {
        vm.newAutoAction[`message_sms_${lang}`] = "";
        vm.newAutoAction[`message_notification_${lang}`] = "";
        vm.newAutoAction[`message_email_${lang}`] = "";
        vm.newAutoAction[`email_subject_${lang}`] = "";
      });
      vm.newAutoAction.message_lang = "fr";
      vm.newAutoAction.message_notification = "";
      vm.newAutoAction.message_sms = "";
      vm.newAutoAction.title = "";
      vm.newAutoAction.recipients = [];
      vm.newAutoAction.email_subject = "";
      vm.newAutoAction.action_type = "email";
      vm.newAutoAction.phone_number = "";
      vm.newAutoAction.phone_number = "";
      vm.newAutoAction.recipient = "";
      vm.newAutoAction.trigger_time = this.$t("trigger_times")[0];
      vm.newAutoAction.status = 0;
      vm.newAutoAction.message = "";
      vm.newAutoAction.action_occur_id = 1;
      vm.newAutoAction.paid_status = null;
      vm.newAutoAction.also_to_guest = 0;
      vm.error = null;
      vm.success = false;
      if (vm.newAutoAction.recipients.length == 0) {
        vm.newAutoAction.recipients.push(store.state.account.email);
      }
      vm.channels.map((channel) => {
        channel.is_checked = true;
      });
      vm.newAutoAction.allChannelsChecked = true;
      vm.areAllChannelsChecked = true;
      vm.findTypeOfSms(true);
    },

    async save_autoaction() {
      const vm = this;
      const lang = vm.newAutoAction.message_lang;
      if (
        vm.newAutoAction.action_type === "email" ||
        vm.newAutoAction.action_type === "review"
      ) {
        vm.newAutoAction.message_email = $("#redactor-uuid-0").html();
        vm.newAutoAction[`message_email_${lang}`] =
          $("#redactor-uuid-0").html();
        vm.newAutoAction[`email_subject_${lang}`] =
          vm.newAutoAction.email_subject;
        vm.newAutoAction.message_sms = "";
        vm.newAutoAction.message_notification = "";
        vm.langs.map((lang) => {
          vm.newAutoAction[`message_sms_${lang}`] = "";
          vm.newAutoAction[`message_notification_${lang}`] = "";
        });
      } else if (vm.newAutoAction.action_type === "sms") {
        vm.newAutoAction.email_subject = "";
        vm.newAutoAction.message_email = "";
        vm.newAutoAction.message_notification = "";
        vm.langs.map((lang) => {
          vm.newAutoAction[`message_email_${lang}`] = "";
          vm.newAutoAction[`message_notification_${lang}`] = "";
          vm.newAutoAction[`email_subject_${lang}`] = "";
        });
      } else if (vm.newAutoAction.action_type === "notification") {
        vm.newAutoAction.message_email = "";
        vm.newAutoAction.phone_number = "";
        vm.newAutoAction.message_sms = "";
        vm.newAutoAction.email_subject = "";
        vm.langs.map((lang) => {
          vm.newAutoAction[`message_email_${lang}`] = "";
          vm.newAutoAction[`message_sms_${lang}`] = "";
          vm.newAutoAction[`email_subject_${lang}`] = "";
        });
      }
      vm.newAutoAction.channel_ids = [];
      if (
        vm.newAutoAction.action_type === "review" ||
        vm.newAutoAction.action_occur_id === 25
      ) {
        vm.newAutoAction.channel_ids.push(1);
      } else {
        let noChannelsSelected = false;
        vm.channels.map((channel) => {
          if (channel.is_checked == true) {
            noChannelsSelected = true;
            vm.newAutoAction.channel_ids.push(channel.id);
          }
        });
        if (noChannelsSelected == false) {
          vm.newAutoAction.channel_ids = null;
        }
      }

      if (
        vm.newAutoAction.action_occur_id === 20 &&
        vm.immediateTiggerTimes.includes(vm.newAutoAction.trigger_time)
      ) {
        vm.newAutoAction.trigger_time = "";
      }

      await automationService.store(vm, vm.newAutoAction);
    },

    async update_autoaction() {
      const vm = this;
      if (vm.phoneError) {
        return;
      }
      const lang = vm.newAutoAction.message_lang;
      if (vm.typeIsEmail || vm.typeIsReview) {
        if (
          vm.newAutoAction.action_type === "email" ||
          vm.newAutoAction.action_type === "review"
        ) {
          vm.newAutoAction.message_email = $("#redactor-uuid-0").html();
          vm.newAutoAction[`message_email_${lang}`] =
            $("#redactor-uuid-0").html();
          vm.newAutoAction[`email_subject_${lang}`] =
            vm.newAutoAction.email_subject;
          vm.newAutoAction.message_sms = "";
          vm.newAutoAction.message_notification = "";
          vm.newAutoAction.phone_number = "";
          vm.langs.map((lang) => {
            vm.newAutoAction[`message_sms_${lang}`] = "";
            vm.newAutoAction[`message_notification_${lang}`] = "";
          });
        }
      } else if (vm.newAutoAction.action_type === "sms") {
        vm.newAutoAction.message_email = "";
        vm.newAutoAction.message_notification = "";
        vm.newAutoAction.email_subject = "";
        vm.langs.map((lang) => {
          vm.newAutoAction[`message_email_${lang}`] = "";
          vm.newAutoAction[`email_subject_${lang}`] = "";
          vm.newAutoAction[`message_notification_${lang}`] = "";
        });
      } else if (vm.newAutoAction.action_type === "notification") {
        vm.newAutoAction.message_email = "";
        vm.newAutoAction.message_sms = "";
        vm.newAutoAction.email_subject = "";
        vm.newAutoAction.phone_number = "";
        vm.langs.map((lang) => {
          vm.newAutoAction[`message_sms_${lang}`] = "";
          vm.newAutoAction[`email_subject_${lang}`] = "";
          vm.newAutoAction[`message_email_${lang}`] = "";
        });
      }

      vm.newAutoAction.channel_ids = [];
      if (
        vm.newAutoAction.action_type === "review" ||
        vm.newAutoAction.action_occur_id === 25
      ) {
        vm.newAutoAction.channel_ids.push(1);
      } else {
        let noChannelsSelected = false;
        vm.channels.map((channel) => {
          if (channel.is_checked == true) {
            noChannelsSelected = true;
            vm.newAutoAction.channel_ids.push(channel.id);
          }
        });
        if (noChannelsSelected == false) {
          vm.newAutoAction.channel_ids = null;
        }
      }
      if (
        vm.newAutoAction.action_occur_id === 20 &&
        vm.immediateTiggerTimes.includes(vm.newAutoAction.trigger_time)
      ) {
        vm.newAutoAction.trigger_time = "";
      }

      await automationService.update(vm, vm.newAutoAction);
    },

    async get_channels() {
      const vm = this;
      await channelService.get(vm);
    },

    async get_autoactions() {
      const vm = this;
      let query = "";
      if (vm.selectedRental != "") {
        query = `?rental_id=${vm.selectedRental}`;
      }
      await automationService.get(vm, query);
    },

    async changeStatus(actionId, actionStatus) {
      const vm = this;
      if (actionStatus) {
        actionStatus = 0;
      } else {
        actionStatus = 1;
      }
      await automationService.changeStatus(vm, actionId, actionStatus);
    },

    edit_autoaction(autoaction) {
      const vm = this;
      const aa = {};
      vm.getSignBeforeDays(autoaction.occur.name);
      Object.assign(aa, autoaction);
      vm.error = null;
      vm.success = false;
      vm.editAutoaction = true;
      vm.newAutoAction = {};
      vm.newAutoAction = aa;
      vm.checkedRentals = {};
      vm.checkedGroups = {};
      if (autoaction.rental_ids != null || autoaction.rental_ids === "a:0:{}") {
        const autoActionRentalIds = PHPUnserialize.unserialize(
          autoaction.rental_ids
        );
        const values = Object.values(autoActionRentalIds);
        for (let i = 0; i < values.length; i++) {
          vm.checkedRentals[values[i]] = true;
        }
        for (let i = 0; i < vm.groups.length; i++) {
          const group = vm.groups[i];
          for (let j = 0; j < group.rentals.length; j++) {
            const rental = group.rentals[j];
            if (!vm.checkedRentals[rental.id]) {
              Vue.set(vm.checkedGroups, group.id, false);
              break;
            }
            Vue.set(vm.checkedGroups, group.id, true);
          }
        }
        for (let j = 0; j < vm.groups.length; j++) {
          if (
            vm.groups[j] &&
            vm.groups[j].rentals.length !== 0 &&
            !vm.checkedGroups[vm.groups[j].id]
          ) {
            vm.allRentals = false;
            break;
          }
          vm.allRentals = true;
        }
      }

      if (
        vm.newAutoAction.rental_ids == [] ||
        vm.newAutoAction.rental_ids == null ||
        vm.newAutoAction.rental_ids == "a:0:{}" ||
        vm.newAutoAction.rental_ids.length == 0
      ) {
        const index = vm.rentals.findIndex((rental) => rental.sms_integration);
        vm.smsIntegration = index !== -1;
      } else {
        const ids = PHPUnserialize.unserialize(autoaction.rental_ids);
        const values = Object.values(ids);
        vm.smsIntegration = false;
        for (let i = 0; i < values.length; i++) {
          const rental = vm.rentals.filter(
            (rental) => rental.id == values[i]
          )[0];
          if (rental && rental.sms_integration) {
            vm.$nextTick(() => {
              vm.smsIntegration = true;
            });
            break;
          }
        }
      }

      if (aa.action_type !== "email") {
        vm.typeIsEmail = false;
      } else {
        vm.typeIsEmail = true;
      }

      const triggerTime = vm.newAutoAction.trigger_time;
      if (triggerTime) {
        if (
          triggerTime !== 0 ||
          (!this.immediateTiggerTimes.includes(triggerTime) &&
            vm.newAutoAction.action_occur_id !== 20)
        ) {
          if (vm.newAutoAction.airbnb_auto_action_id != null) {
            vm.newAutoAction.trigger_time = vm.getTriggerTimeName(
              triggerTime,
              vm.newAutoAction.occur.name,
              true
            );
          } else {
            vm.newAutoAction.trigger_time = vm.getTriggerTimeName(
              triggerTime,
              vm.newAutoAction.occur.name
            );
          }
        }
        if (this.immediateTiggerTimes.includes(triggerTime)) {
          vm.newAutoAction.trigger_time = vm.$t("trigger_times[0]");
        }
        if (vm.newAutoAction.action_occur_id === 20) {
          vm.newAutoAction.trigger_time = triggerTime;
        }
      }
      vm.newAutoAction.message_email = aa.message_email_fr;
      vm.newAutoAction.message_sms = aa.message_sms_fr;
      vm.newAutoAction.message_notification = aa.message_notification_fr;
      vm.newAutoAction.email_subject = aa.email_subject_fr;
      vm.newAutoAction.message_lang = "fr";
      $("#redactor-uuid-0").html(vm.newAutoAction.message_email);
      if (
        vm.newAutoAction.channel_ids == null ||
        vm.newAutoAction.channel_ids.length === vm.channels.length
      ) {
        vm.areAllChannelsChecked = true;
        vm.channels.map((channel) => {
          channel.is_checked = true;
        });
      } else if (vm.channels.length > 0) {
        let allChecked = true;
        vm.channels.map((channel) => {
          if (vm.newAutoAction.channel_ids.includes(channel.id)) {
            channel.is_checked = true;
            vm.channel_ids.push(channel.id);
          } else {
            channel.is_checked = false;
            vm.areAllChannelsChecked = false;
            allChecked = false;
          }
        });
        if (allChecked) {
          vm.areAllChannelsChecked = true;
        }
      }
      $("#redactor-uuid-0").html(vm.newAutoAction.message_email);
      vm.changeAutoaction();

      setTimeout(() => {
        vm.openModal("#automation-modal");
      }, 100);

      if ([6, 7].includes(vm.newAutoAction.action_occur_id)) {
        const x = $("#redactor-toolbar-0 li:last-child a");
        if (x.attr("alt") === "Shortcode") {
          x.css({ display: "none" });
        }
      }
    },

    stripeHtmlToText(html) {
      const temporalDivElement = document.createElement("div");
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html;
      // Retrieve the text property of the element (cross-browser support)
      return (
        temporalDivElement.textContent || temporalDivElement.innerText || ""
      );
    },

    async delete_autoaction(autoactioId) {
      const vm = this;
      swal(
        {
          title: vm.$t("swal_popup.are_you_sure"),
          text: `<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>${vm.$t(
            "swal_popup.not_able_to_recover"
          )}</div>`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: vm.$t("swal_popup.confirm_delete"),
          cancelButtonText: vm.$t("swal_popup.cancel"),
          closeOnConfirm: false,
          html: true,
        },
        () => {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();
          automationService.destroy(vm, autoactioId);
        }
      );
    },

    resetData() {
      const vm = this;
      vm.editAutoaction = false;
      vm.newAutoAction = Object.assign({}, vm.defaultNewAutoAction);
    },

    changeAutoaction() {
      const vm = this;
      this.selectedActionOccur = this.action_occurs.find(
        (obj) => obj.id === this.newAutoAction.action_occur_id
      );

      if (
        (this.newAutoAction.action_occur_id == 9 &&
          this.newAutoAction.message_email == "") ||
        this.newAutoAction.message_sms == ""
      ) {
        this.newAutoAction.message = `${this.$t(
          "automation.index.the_following_payment_has_been_viewed"
        )} \n\n${this.$t("input.title")} : [[TITLE]] \n${this.$t(
          "input.description"
        )} : [[DESCRIPTION]] \n${this.$t(
          "input.amount"
        )} : [[AMOUNT]] \n${this.$t("input.link")} : [[LINK]]`;
      }

      if (this.newAutoAction.action_occur_id !== 5 && this.typeIsReview) {
        this.typeIsReview = false;
        this.typeIsEmail = true;
        this.channel_id = null;
        this.newAutoAction.action_type = this.actionType.email;
        this.channels.map((channel) => (channel.is_checked = true));
        this.areAllChannelsChecked = true;
      }
      const x = $("#redactor-toolbar-0 li:last-child a");
      if ([6, 7].includes(this.newAutoAction.action_occur_id)) {
        if (x.attr("alt") === "Shortcode") {
          x.css({ display: "none" });
        }
      } else {
        x.css({ display: "block" });
      }
    },

    findTypeOfSms(isFromNewAutoAction = false) {
      const vm = this;
      const lang = vm.newAutoAction.message_lang;
      const type = vm.newAutoAction.action_type;
      if (
        vm.newAutoAction.action_type == vm.actionType.sms ||
        vm.newAutoAction.action_type == vm.actionType.notification
      ) {
        vm.typeIsEmail = false;
        vm.typeIsReview = false;
        vm.newAutoAction.channel_id = null;
      } else if (vm.newAutoAction.action_type == vm.actionType.sendReview) {
        vm.typeIsEmail = false;
        vm.typeIsReview = true;
        vm.newAutoAction.channel_id = 1;
      } else {
        vm.newAutoAction.channel_id = null;
        vm.typeIsEmail = true;
        vm.typeIsReview = false;
        if (!isFromNewAutoAction) {
          vm.$nextTick(() => {
            $("#redactor-uuid-0").html(
              vm.newAutoAction[`message_email_${lang}`]
            );
          });
        }
      }
      vm.newAutoAction[`message_${type}`] = "";
      vm.newAutoAction[`message_${type}`] =
        vm.newAutoAction[`message_${type}_${lang}`];
    },

    insertShortcodeToText() {
      const vm = this;
      if (vm.shortCodeForSubject) {
        const cursorPosition = $("#auto-action-email-subject").prop(
          "selectionStart"
        );
        vm.newAutoAction.email_subject = vm.newAutoAction.email_subject
          ? `${vm.newAutoAction.email_subject.substring(0, cursorPosition)}${
              vm.selectedShortCode
            }${vm.newAutoAction.email_subject.substring(cursorPosition)}`
          : vm.selectedShortCode;
      } else if (vm.typeIsEmail) {
        vm.newAutoAction.message_email = $("#redactor-uuid-0").html();
      } else if (vm.newAutoAction.action_type === "sms") {
        const cursorPosition = $("#auto-action-sms-content").prop(
          "selectionStart"
        );
        vm.newAutoAction.message_sms = vm.newAutoAction.message_sms
          ? `${vm.newAutoAction.message_sms.substring(0, cursorPosition)}${
              vm.selectedShortCode
            }${vm.newAutoAction.message_sms.substring(cursorPosition)}`
          : vm.selectedShortCode;
      } else if (vm.newAutoAction.action_type === "notification") {
        const cursorPosition = $("#auto-action-notification-content").prop(
          "selectionStart"
        );
        vm.newAutoAction.message_notification = vm.newAutoAction
          .message_notification
          ? `${vm.newAutoAction.message_notification.substring(
              0,
              cursorPosition
            )}${
              vm.selectedShortCode
            }${vm.newAutoAction.message_notification.substring(cursorPosition)}`
          : vm.selectedShortCode;
      }
      vm.notificationActionTypesContentChange(
        vm.newAutoAction.action_type,
        vm.newAutoAction.message_lang
      );
      vm.$forceUpdate();
      vm.closeModal("#shortcode-list-modal");
      vm.openModal("#automation-modal");
      vm.shortCodeForSubject = false;
    },

    openShortcodeListModal(name, subject = false) {
      if (subject) {
        this.shortCodeForSubject = true;
      }
      if (this.langs.indexOf(localStorage.getItem("lang")) === -1) {
        this.shortCodeName = "name_en";
      } else {
        this.shortCodeName = `name_${localStorage.getItem("lang")}`;
      }
      this.openModal(name);
    },

    closeAndOpenModals() {
      this.closeModal("#shortcode-list-modal");
      this.openModal("#automation-modal");
    },

    updateparent() {
      const vm = this;
      vm.get_autoactions();
    },

    getTriggerTimeName(triggerTime, occurName, airbnb = false) {
      const vm = this;
      if (
        occurName == "after-booking" ||
        occurName == "after-checkin" ||
        occurName == "after-checkout" ||
        occurName == "before-checkout" ||
        occurName == "before-checkin" ||
        occurName == "after-payment-view" ||
        occurName == "after-payment-link-ko" ||
        occurName == "after-deposit-link-ko"
      ) {
        if (triggerTime) {
          const explodedTime = triggerTime.toString().split(" ");
          if (explodedTime[1]) {
            if (vm.minutes.includes(explodedTime[1])) {
              // trigger time is minutes
              const number = Number(explodedTime[0]);

              return `${number} ${vm.$t(
                "automation.index.trigger_time_names.minutes"
              )}`;
            }

            if (vm.days.includes(explodedTime[1])) {
              // trigger time is hour
              const number = Number(explodedTime[0]);

              if (number > 1) {
                return `${number} ${vm.$t(
                  "automation.index.trigger_time_names.hours"
                )}`;
              }

              return `${number} ${vm.$t(
                "automation.index.trigger_time_names.hour"
              )}`;
            }

            // trigger time is day
            let number = Number(explodedTime[0]);
            if (airbnb) {
              number -= 1;
            }
            if (number > 1) {
              return `${number} ${vm.$t(
                "automation.index.trigger_time_names.days"
              )}`;
            }
            return `${number} ${vm.$t(
              "automation.index.trigger_time_names.day"
            )}`;
          } else if (airbnb) {
            let number = Number(explodedTime[0]);
            if (airbnb) {
              number -= 1;
            }
            if (number > 1) {
              return `${number} ${vm.$t(
                "automation.index.trigger_time_names.days"
              )}`;
            }
            return `${number} ${vm.$t(
              "automation.index.trigger_time_names.day"
            )}`;
          }
        }
      } else if (occurName === "specific-day") {
        moment.locale("fr", {
          months: vm.$t("months"),
          weekdaysShort: vm.$t("medWeekDays"),
          monthsShort: vm.$t("shortMonths"),
        });
        if (triggerTime.includes("-")) {
          return moment(triggerTime).format("ddd DD MMMM YYYY HH:mm:ss");
        }
        return triggerTime;
      } else {
        return triggerTime;
      }
    },

    setTriggerTimeDependingFromLang() {
      const vm = this;

      vm.occurs.forEach((occur) => {
        if (occur.autoactions.length > 0) {
          occur.autoactions.forEach((action) => {
            if (
              occur.name !== "temperature" &&
              occur.name !== "noise-sound" &&
              occur.name !== "specific-day"
            ) {
              if (
                !this.immediateTiggerTimes.includes(action.trigger_time) &&
                action.trigger_time !== 0 &&
                action.trigger_time != null
              ) {
                action.trigger_time = vm.getTriggerTimeName(
                  action.trigger_time,
                  action.occur.name
                );
              } else {
                action.trigger_time = vm.$t("trigger_times[0]");
              }
            }
          });
        }
      });
    },

    getSignBeforeDays(occurName) {
      const vm = this;
      const res = occurName.split("-");
      if (res && res[0] && res[1] && res[0] == "before") {
        vm.signBeforeDays = "- ";
      } else if (res && res[0] && res[1] && res[0] == "after") {
        vm.signBeforeDays = "+ ";
      } else {
        vm.signBeforeDays = "";
      }
    },

    filterByRentals(id = null) {
      const vm = this;
      const rentals = [];
      if (id == "all") {
        for (let i = 0; i < vm.rentals.length; i++) {
          Vue.set(vm.checkedRentals, vm.rentals[i].id, vm.allRentals);
        }
        for (let j = 0; j < vm.groups.length; j++) {
          Vue.set(vm.checkedGroups, vm.groups[j].id, vm.allRentals);
        }
      } else if (id != null) {
        const group = vm.groups.filter((g) => g.id === id)[0];
        const groupRentals = group.rentals;
        for (let i = 0; i < groupRentals.length; i++) {
          Vue.set(vm.checkedRentals, groupRentals[i].id, vm.checkedGroups[id]);
        }
        for (let j = 0; j < vm.groups.length; j++) {
          if (
            vm.groups[j] &&
            vm.groups[j].rentals.length !== 0 &&
            !vm.checkedGroups[vm.groups[j].id]
          ) {
            vm.allRentals = false;
            break;
          }
          vm.allRentals = true;
        }
      } else {
        for (let i = 0; i < vm.groups.length; i++) {
          const group = vm.groups[i];
          for (let j = 0; j < group.rentals.length; j++) {
            const rental = group.rentals[j];
            if (!vm.checkedRentals[rental.id]) {
              Vue.set(vm.checkedGroups, group.id, false);
              break;
            }
            Vue.set(vm.checkedGroups, group.id, true);
          }
        }
        for (let j = 0; j < vm.groups.length; j++) {
          if (
            vm.groups[j] &&
            vm.groups[j].rentals.length !== 0 &&
            !vm.checkedGroups[vm.groups[j].id]
          ) {
            vm.allRentals = false;
            break;
          }
          vm.allRentals = true;
        }
      }
      for (const k in vm.checkedRentals) {
        if (vm.checkedRentals[k] === true) {
          rentals.push(parseInt(k));
        }
      }
      vm.newAutoAction.rental_ids = rentals;
    },

    getOtherRentals() {
      // get rentals which are not in any groups
      const vm = this;
      const removed = [];
      const isGroups = vm.groups.length > 0;
      // if there are not groups then all rentals will be in 'others' group
      if (!isGroups) {
        const group = {
          id: 0,
          name: "others",
          rentals: vm.others,
        };
        Vue.set(vm.groups, vm.groups.length, group);
      }
      for (let i = 0; i < vm.rentals.length; i++) {
        const rental = vm.rentals[i];
        for (let j = 0; j < vm.groups.length; j++) {
          const group = vm.groups[j];
          const check = group.rentals.filter((r) => r.id === rental.id);
          if (check.length > 0) {
            const check1 = vm.others.filter((r) => r.id === rental.id);
            if (check1.length > 0) {
              const index = vm.others.indexOf(rental);
              vm.others.splice(index, 1);
              break;
            }
            removed.push(rental);
          } else {
            const check2 = vm.others.filter((r) => r.id === rental.id);
            if (check2.length === 0 && !removed.includes(rental)) {
              vm.others.push(rental);
            }
          }
        }
      }
      // add group with rentals which are not in any groups
      if (isGroups && vm.others.length > 0) {
        const group = {
          id: 0,
          name: "others",
          rentals: vm.others,
        };
        Vue.set(vm.groups, vm.groups.length, group);
      }
      return vm.others;
    },

    getAutoactionRentalName(action) {
      const vm = this;
      const ids = action.rental_ids;
      if (ids == null || ids == [] || ids == "a:0:{}") {
        return vm.$t("automation.index.modal.all_rentals");
      }
      const autoActionRentalIds = PHPUnserialize.unserialize(ids);
      const values = Object.values(autoActionRentalIds);
      let names = "";
      let count = 0;
      for (let i = 0; i < values.length; i++) {
        const rental = vm.rentals.filter((rental) => rental.id == values[i])[0];
        if (rental) {
          names += `${rental.name}\n`;
          count++;
        }
      }
      if (count == vm.rentals.length || count == 0) {
        return vm.$t("automation.index.modal.all_rentals");
      }
      return names;
    },

    getAutoactionChannelName(action) {
      const vm = this;
      const ids = action.channel_ids;
      let channelNames = "";
      if (ids != null) {
        if (action.allChannelsChecked) {
          return vm.$t("automation.index.modal.all_channels");
        }
        vm.channels.map((channel) => {
          if (action.channel_ids.includes(channel.id)) {
            channelNames += `${channel.name}\n`;
          }
        });
        return channelNames;
      }
      return vm.$t("automation.index.modal.all_channels");
    },

    duplicate_autoaction(autoactionId) {
      const vm = this;
      vm.loading = true;
      automationService.duplicate(vm, autoactionId);
    },

    change_tab(tab = null) {
      const vm = this;
      if (tab) {
        vm.activeTab = tab;
        if (vm.activeTab === "autoactions") {
          Vue.router.push({
            name: "automation.index",
          });
        } else if (vm.activeTab === "shortcodes") {
          Vue.router.push({
            name: "automation.custom-short-codes",
          });
        }
      } else if (vm.$route.path == "/automation/custom-short-codes") {
        vm.activeTab = "shortcodes";
        Vue.router.push({
          name: "automation.custom-short-codes",
        });
      }
    },

    new_custom_short_code() {
      const vm = this;
      vm.editShortCode = false;
      vm.newShortCode = {
        id: "",
        title: "",
        code: "",
        content: "",
      };
      vm.shortCodeRentalGroups.map((group, index) => {
        group.rentals.map((rental) => {
          rental.short_code_text = "";
        });
      });
      vm.openModal("#new-custom-short-code-modal");
    },

    async save_short_code() {
      const vm = this;
      const data = {
        title: vm.newShortCode.title,
        content: vm.newShortCode.content,
        rentals: [],
      };
      const rentalData = {
        id: "",
        short_code_text: "",
      };
      if (vm.shortCodeRentalGroups.length > 0) {
        vm.shortCodeRentalGroups.map((group) => {
          group.rentals.map((rental) => {
            rentalData.id = rental.id;
            rentalData.short_code_text = rental.short_code_text;
            const rentalDataNew = { ...rentalData };
            data.rentals.push(rentalDataNew);
          });
        });
        vm.smallLoading = true;
        await automationService.storeCustomShortCode(vm, data);
      }
    },
    edit_short_code(shortCode) {
      const editedShortCode = { ...shortCode };
      const vm = this;
      vm.newShortCode = {};
      vm.newShortCode.id = editedShortCode.id;
      vm.newShortCode.title = editedShortCode.title;
      vm.newShortCode.code = editedShortCode.code;
      vm.newShortCode.content = editedShortCode.content;
      vm.editShortCode = true;

      const shortCodeRentalList = editedShortCode.rentals;

      vm.shortCodeRentalGroups.map((group) => {
        group.rentals.map((rental) => {
          for (const item in shortCodeRentalList) {
            if (shortCodeRentalList[item].id == rental.id) {
              rental.short_code_text =
                shortCodeRentalList[item].pivot.short_code_text;
            }
          }
        });
      });
      vm.openModal("#new-custom-short-code-modal");
    },
    async update_short_code() {
      const vm = this;
      const data = {
        id: vm.newShortCode.id,
        title: vm.newShortCode.title,
        content: vm.newShortCode.content,
        rentals: [],
      };
      const rentalData = {
        id: "",
        short_code_text: "",
      };
      if (vm.shortCodeRentalGroups.length > 0) {
        vm.shortCodeRentalGroups.map((group) => {
          group.rentals.map((rental) => {
            rentalData.id = rental.id;
            rentalData.short_code_text = rental.short_code_text;
            const rentalDataNew = { ...rentalData };
            data.rentals.push(rentalDataNew);
          });
        });
        vm.smallLoading = true;
        await automationService.updateCustomShortCode(vm, data);
      }
    },
    delete_short_code(shortCodeId) {
      const vm = this;
      swal(
        {
          title: vm.$t("swal_popup.are_you_sure"),
          text: `<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>${vm.$t(
            "swal_popup.not_able_to_delete_custom_short_code"
          )}</div>`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: vm.$t("swal_popup.confirm_delete"),
          cancelButtonText: vm.$t("swal_popup.cancel"),
          closeOnConfirm: false,
          html: true,
        },
        () => {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();
          automationService.deleteCustomShortCode(vm, shortCodeId);
        }
      );
    },
    get_custom_short_codes() {
      const vm = this;
      automationService.getCustomShortCodes(vm);
    },
    resetCustomShortCodeData() {
      const vm = this;
      vm.editShortCode = false;
      vm.newShortCode = {};
      vm.shortCodeRentalGroups.map((group) => {
        group.rentals.map((rental) => {
          rental.short_code_text = "";
        });
      });
    },
    filterByChannels(id = null) {
      const vm = this;
      if (id === "all") {
        vm.channels.map((channel) => {
          channel.is_checked = vm.areAllChannelsChecked;
        });
      } else if (id != null) {
        let bigState = false;
        vm.channels.map((channel) => {
          if (channel.is_checked === false) {
            bigState = true;
          }
          if (channel.id === id) {
            const state = channel.is_checked;
            channel.is_checked = state;
          }
        });
        if (bigState !== true) {
          vm.areAllChannelsChecked = true;
        } else {
          vm.areAllChannelsChecked = false;
        }
        vm.$forceUpdate();
      }
    },
    open_test_notification_modal(autoactionId) {
      const vm = this;
      vm.testNotificationData = {
        booking_id: "",
        email: "",
        autoaction_id: autoactionId,
      };
      vm.openModal("#test-notification-modal");
    },
    close_test_notification_modal(selector) {
      const vm = this;
      vm.closeModal(selector);
      vm.testNotificationData = {
        booking_id: "",
        email: "",
      };
    },
    send_test_notification() {
      const vm = this;
      vm.smallLoading = true;
      automationService.sendTestNotification(vm, vm.testNotificationData);
    },
    notificationContentLangChange(type, lang) {
      const vm = this;
      vm.newAutoAction.email_subject = "";
      vm.newAutoAction.email_subject =
        vm.newAutoAction[`email_subject_${lang}`];
      if (type === "email" || type === "review") {
        $("#redactor-uuid-0").html("");
        $("#redactor-uuid-0").html(vm.newAutoAction[`message_email_${lang}`]);
      } else {
        vm.newAutoAction[`message_${type}`] = "";
        vm.newAutoAction[`message_${type}`] =
          vm.newAutoAction[`message_${type}_${lang}`];
      }
      vm.$forceUpdate();
    },
    notificationActionTypesContentChange(type, lang) {
      const vm = this;
      if (type === "email") {
        vm.emailSubjectChange(type, lang);
      }
      if (type === "review") {
        type = "email";
      }
      vm.newAutoAction[`message_${type}_${lang}`] =
        vm.newAutoAction[`message_${type}`];
    },
    checkEmailTypeContent(type, lang) {
      const vm = this;
      vm.newAutoAction[`message_${type}_${lang}`] =
        $("#redactor-uuid-0").html();
    },
    emailSubjectChange(type, lang) {
      const vm = this;
      if (type === "email") {
        vm.newAutoAction[`email_subject_${lang}`] =
          vm.newAutoAction.email_subject;
      }
    },
    getTriggerTimeContent(occurId) {
      if (occurId !== 20) {
        return `${this.$t(
          "automation.index.modal.specific_time_pop_up"
        )} ${this.$t("automation.index.modal.trigger_time_info")}`;
      }
      return this.$t("automation.index.modal.specific_time_pop_up");
    },
    changeSelectedShortCode(newSelectedShortCode) {
      this.selectedShortCode = newSelectedShortCode;
    },
    focusElement(elemRef, elemObject, elemType) {
      this.focusedElement =
        elemType === "content" ? this.$refs[elemRef] : this.$refs[elemRef][0];
      this.focusedElementObject = elemObject;
      this.focusedElementType = elemType;
    },
    insertShortcodeToCustomShortCodeText() {
      const cursorPosition = this.focusedElement.selectionStart;
      const focusedElementType = this.focusedElementType;
      let text = "";

      if (cursorPosition !== undefined) {
        text = this.focusedElementObject[focusedElementType];
        this.focusedElementObject[focusedElementType] = text
          ? `${text.substring(0, cursorPosition)}${
              this.selectedShortCode
            }${text.substring(cursorPosition)}`
          : this.selectedShortCode;
      } else {
        toastr.error(
          this.$t(
            "account.settings.message_templates_section.select_cursor_place"
          )
        );
      }
      this.focusedElement = "";
      this.focusedElementObject = {};
      this.focusedElementType = "";

      this.closeAndOpenModals();
    },
    exportNotifications() {
      this.loading = true;
      automationService.exportNotifications(this);
    },
    openImportNotificationsModal() {
      this.openModal("#import-notifications");
    },
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
    isEnvironmentOccur() {
      return (
        this.selectedActionOccur.name === "temperature" ||
        this.selectedActionOccur.name === "co2" ||
        this.selectedActionOccur.name === "noise-sound"
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/automation/index/index.js